import { AdditionalColumnCellProps } from "PFApp/activities/manage_roles/parts/additional_column_cell/additional_column_cell.types";
import { Stack } from "PFComponents/containers";
import { ActivityCustomField } from "PFTypes";
import { useWatch } from "react-hook-form";

import css from "../cell.module.scss";

const CUSTOM_FIELDS_KEY = "custom_fields";
const ACTIVITY_TAG_KEY = "activity_tag";

export const ActivityTagAdditionalColumnCell = ({
  column,
  rolesFormKey,
  renderCell,
  info
}: AdditionalColumnCellProps) => {
  const customFieldsPath = `${rolesFormKey}.${info.row.index}.original.${CUSTOM_FIELDS_KEY}`;

  const customFields = useWatch({ name: customFieldsPath }) as ActivityCustomField[];
  const activityTags = customFields?.find(({ type }) => type.name === ACTIVITY_TAG_KEY)?.values ?? null;

  return <Stack className={css.cell}>{renderCell(column)({ ...info, getValue: () => activityTags })}</Stack>;
};
